import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import apiConfig from "../../../../apiConfig";

const ReleaseHoldAmount = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const [actionLoadingId, setActionLoadingId] = useState(null);

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const res = await axios.get(
        `${apiConfig.baseUrl}${apiConfig.GetSellerWithdrawalRequests}`,
      );
      setRequests(res.data.data || []);
    } catch (error) {
      toast.error("Failed to load withdraw requests");
    } finally {
      setLoading(false);
    }
  };

  const releaseHold = async (id) => {
    try {
      setActionLoadingId(id); 
      await axios.put(
        `${apiConfig.baseUrl}${apiConfig.ReleaseHoldAmount}/${id}`,
      );

      toast.success("Hold amount released successfully");

      fetchRequests();
    } catch (error) {
      toast.error(error?.response?.data?.message || "Release failed");
    } finally {
      setActionLoadingId(null); 
    }
  };

  if (loading) {
    return <p className="text-center mt-10">Loading requests...</p>;
  }

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-5">Withdraw Hold Management</h2>

      <div className="overflow-x-auto">
        <table className="w-full border rounded-lg">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3">Seller</th>
              <th className="p-3">Requested</th>
              <th className="p-3">Approved</th>
              <th className="p-3">Hold</th>
              <th className="p-3">Hold Reason</th>
              <th className="p-3">Status</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {requests.length === 0 ? (
              <tr>
                <td colSpan="7" className="text-center p-4">
                  No requests found
                </td>
              </tr>
            ) : (
              requests.map((item) => (
                <tr key={item._id} className="border-t">
                  <td className="p-3">{item.sellerName}</td>

                  <td className="p-3">₹{item.requestedAmount}</td>

                  <td className="p-3">₹{item.approvedAmount}</td>

                  <td className="p-3 text-red-600 font-semibold">
                    ₹{item.holdAmount}
                  </td>

                  <td className="p-3">{item.holdReason || "-"}</td>

                  <td className="p-3">
                    <span
                      className={`px-3 py-1 rounded-full text-sm ${
                        item.status === "approved"
                          ? "bg-green-100 text-green-700"
                          : "bg-yellow-100 text-yellow-700"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td className="p-3">
                    {item.holdAmount > 0 && !item.holdReleased ? (
                      <button
                        onClick={() => releaseHold(item._id)}
                        disabled={actionLoadingId === item._id}
                        className="bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 disabled:opacity-50"
                      >
                        {actionLoadingId === item._id
                          ? "Releasing..."
                          : "Release Hold"}
                      </button>
                    ) : (
                      <span className="text-gray-400 text-sm">Released</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ReleaseHoldAmount;
